import AppConstants from '../Constants/AppConstants';

// Keep storage in MB in Skua. It makes policies readable for operators while
// the application can still compare the value with browser File sizes in
// bytes. Do not use a bare `storage` key: it is ambiguous (MB, GB, or bytes).
export const STORAGE_ENTITLEMENT_KEY = 'storage_mb';
const BYTES_PER_MB = 1024 * 1024;

// Numeric allowances come from Skua's `allowed` plan-features payload. An
// absent value means the policy has not set a numeric cap for that feature.
export const getFeatureLimit = featureKey => {
  const value = AppConstants.featureEntitlements?.[featureKey];
  if (typeof value !== 'number' && typeof value !== 'string') {
    return null;
  }

  const limit = Number(value);
  return Number.isFinite(limit) && limit >= 0 ? limit : null;
};

export const hasReachedFeatureLimit = (featureKey, currentCount) => {
  const limit = getFeatureLimit(featureKey);
  return limit !== null && Number(currentCount || 0) >= limit;
};

export const getStorageLimitBytes = () => {
  const limitInMb = getFeatureLimit(STORAGE_ENTITLEMENT_KEY);
  if (limitInMb === null) {
    return null;
  }
  return limitInMb * BYTES_PER_MB;
};

// `usedBytes` must come from the API that owns the tenant's media storage.
// Never estimate it from the currently visible media page: folders and
// pagination would silently undercount a tenant's real usage.
export const canStoreAdditionalBytes = (usedBytes, additionalBytes) => {
  const limit = getStorageLimitBytes();
  if (limit === null) return true;

  const used = Number(usedBytes);
  const additional = Number(additionalBytes);
  if (!Number.isFinite(used) || used < 0 || !Number.isFinite(additional) || additional < 0) {
    return false;
  }

  return used + additional <= limit;
};

export const formatStorageBytes = bytes => {
  const value = Number(bytes);
  if (!Number.isFinite(value) || value < 0) {
    return '—';
  }
  if (value < BYTES_PER_MB) {
    return `${Math.ceil(value / 1024)} KB`;
  }
  return `${(value / BYTES_PER_MB).toFixed(value >= 100 * BYTES_PER_MB ? 0 : 1)} MB`;
};
